/** Copy of the vendorPayments page (Operations), ported from VentaHub. */
export const vendorPayments = {
  words: {
    noun: 'payment',
    record: 'Record a payment',
    document: 'vendor invoice',
    settled: 'paid',
  },
  title: 'Vendor payments',
  description: 'Payments made to vendors against their invoices.',
  empty: 'No vendor payments to show',
  emptyHint: 'Nothing matches these filters.',
  filters: {
    warehouse: 'Warehouse',
    party: 'Vendor',
    invoice: 'Vendor invoice',
    dates: 'Paid on',
    void: 'Include voided',
  },
  columns: {
    date: 'Paid on',
    invoice: 'Vendor invoice',
    amount: 'Amount',
    comment: 'Comment',
    valid: 'Status',
  },
} as const
